<template>
  <div>
    <div class="content-commod">
      <ul>
        <li class="main-row">
          <span>3D挂件属性</span>
          <div class="details-row">
            <div v-if="pedant.position">
              坐标:X:<input
                type="number"
                v-model.number="pedant.position.x"
                style="width: 60px"
              />
              Y:<input
                type="number"
                v-model.number="pedant.position.y"
                style="width: 60px"
              />
              <br />
              <span
                style="
                  color: rgb(189, 189, 189);
                  margin: 10px auto;
                  font-size: 14px;
                "
                ><i class="iconfont icon-gantanhao">提示:</i>
                坐标位置根据场景渲染器中心点计算</span
              >
            </div>
            <div v-if="pedant.rotation || pedant.rotation === 0">
              旋转:X:<input
                type="number"
                v-model.number="pedant.rotation.x"
                style="width: 60px"
              />
              Y:<input
                type="number"
                v-model.number="pedant.rotation.y"
                style="width: 60px"
              />
            </div>
            <div v-if="pedant.scale">
              缩放:X:<input
                step="0.1"
                type="number"
                v-model.lazy.number="pedant.scale.x"
                style="width: 60px"
              />
              Y:
              <input
                step="0.1"
                type="number"
                v-model.lazy.number="pedant.scale.y"
                style="width: 60px"
              />
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      pedant: {}
    }
  },
  created () {
    // console.log('Tabcommodity获取的t9video.videoobj', this.t9video.videoobj)
    this.transfrom()
  },
  props: {
    resid: {
      type: String,
      default: ''
    },
    t9video: {
      type: Object,
      default: function () {
        return {}
      }
    },
  },
  methods: {
    transfrom () {
      // 父组件调用该方法更新this.commodity数据
      // console.log('id', this.resid)
      let comIndex = this.t9video.videoobj.scenes[0].res.findIndex((item) => item.resid == this.resid)
      // console.log('comIndex', comIndex)
      this.pedant = this.t9video.videoobj.scenes[0].res[comIndex]
      // console.log('tabpadant.pedant', this.pedant)
    },
  },

  // 监听commodity
  watch: {
    resid: {
      handler (newVal, oldVal) {
        console.log("pedant", this.t9video.videoobj.scenes[0])
        if (oldVal != null) {
          this.transfrom()
          // this.$emit('setScene', this.t9video.videoobj.scenes[0])
        }
      },
      deep: true
    },
    pedant: {
      handler (newVal, oldVal) {
        // console.log('pedant', newVal, 'old', !!oldVal)
        // this.$emit('setScene', this.t9video.videoobj.scenes[0])
        if (!!oldVal && newVal.resid == oldVal.resid) {
          console.log('pedant', newVal, 'old', oldVal)
          this.$emit('setScene', this.t9video.videoobj.scenes[0])
        }
      },
      deep: true
    },

  }

}
</script>

<style lang="scss" scoped>
.content-commod {
  //   .BN {

  //   }
  ul {
    border: none;
  }
  .main-row {
    padding: 10px;
    > span {
      font-size: 16px;
      font-weight: bold;
      border-left: 4px solid #ffacb7;
      padding-left: 10px;
    }
    .slider-row {
      display: flex;

      margin: 15px;
    }
    .details-row {
      // height: 30px;
      line-height: 60px;
      margin: 0 10px;
      //   display: flex;
      justify-content: space-between;
    }

    &:last-child {
      border-bottom: none;
    }
  }
}
</style>